// Live search for the FCC "Make Eligible" form. The candidate pool is the
// whole user table (4k+ rows and growing), far too big for a <select>, so
// this queries a page of matches from the server as the admin types instead.
//
// Delegated from the document so it keeps working after a redirect
// re-renders the eligibility tab, matching fcc-copy-share-link.js.

const DEBOUNCE_MS = 250;
const MIN_QUERY_LENGTH = 2;

function escapeHtml(value) {
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

function elements(form) {
  return {
    input: form.querySelector("[data-fcc-candidate-search-input]"),
    results: form.querySelector("[data-fcc-candidate-search-results]"),
    userId: form.querySelector("[data-fcc-candidate-search-id]"),
    submit: form.querySelector("[data-fcc-candidate-search-submit]"),
    url: form.querySelector("[data-fcc-candidate-search-url]")?.dataset.fccCandidateSearchUrl,
  };
}

function clearSelection({ userId, submit }) {
  userId.value = "";
  submit.disabled = true;
}

function hideResults(results) {
  results.hidden = true;
  results.innerHTML = "";
}

function renderResults(refs, candidates) {
  const { results } = refs;

  if (!candidates.length) {
    results.innerHTML = '<li class="fcc-usersearch-empty">No matching users</li>';
    results.hidden = false;
    return;
  }

  results.innerHTML = candidates
    .map((candidate) => `<li data-id="${candidate.id}" data-email="${escapeHtml(candidate.email)}">${escapeHtml(candidate.email)}</li>`)
    .join("");
  results.hidden = false;
}

async function search(refs, query) {
  const response = await fetch(`${refs.url}?q=${encodeURIComponent(query)}`, {
    headers: { Accept: "application/json" },
  });
  if (!response.ok) return;

  renderResults(refs, await response.json());
}

document.addEventListener("input", (event) => {
  const input = event.target.closest("[data-fcc-candidate-search-input]");
  if (!input) return;

  const form = input.closest("[data-fcc-candidate-search]");
  const refs = elements(form);

  clearSelection(refs);

  const query = input.value.trim();
  window.clearTimeout(input.fccSearchTimer);

  if (query.length < MIN_QUERY_LENGTH) {
    hideResults(refs.results);
    return;
  }

  input.fccSearchTimer = window.setTimeout(() => search(refs, query), DEBOUNCE_MS);
});

document.addEventListener("click", (event) => {
  const item = event.target.closest("[data-fcc-candidate-search-results] li[data-id]");
  if (!item) return;

  const form = item.closest("[data-fcc-candidate-search]");
  const refs = elements(form);

  refs.input.value = item.dataset.email;
  refs.userId.value = item.dataset.id;
  refs.submit.disabled = false;
  hideResults(refs.results);
});

// Clicking anywhere outside a search box just closes its open results list.
document.addEventListener("click", (event) => {
  document.querySelectorAll("[data-fcc-candidate-search-results]:not([hidden])").forEach((results) => {
    if (results.closest(".fcc-usersearch")?.contains(event.target)) return;
    hideResults(results);
  });
});
